import { requestForApi } from "../../utils/httpUtil";


export async function queryAncientInspect(pageSize: number, current: number, key?: string) {
    const resp = await requestForApi(`/api/v1/garden/ancients/inspects/search?pageSize=${pageSize}&current=${current}&key=${key ? key : ''}`,
        {
            method: 'GET',
        });

    if (resp.result) {
        return Promise.resolve({
            data: resp.data?.list,
            success: true,
            total: resp.data?.pagination?.total,
            pageSize: resp.data?.pagination?.pageSize,
            current: resp.data?.pagination?.current,
        });
    }
    return Promise.resolve({
        data: [],
        success: false,
        total: 0,
        pageSize: 20,
        current: 1,
    });
}

/**
 *
 * @param id 根据ID拿到古树巡查对象
 */
export async function queryAncientInspectById(id: string) {
    return requestForApi(`/api/v1/garden/ancients/inspects/${id}`, {
        method: 'GET',
    });
}
